export default {
  ACCESS_TOKEN: 'accessToken',
  USER: 'user'
};
